type TranslationTree = { [key: string]: string | TranslationTree };

/**
 * Returns a copy of French translations whose punctuation spaces cannot break:
 * a narrow no-break space (U+202F) before `? ! ;`, a no-break space (U+00A0)
 * before `:` and inside `« »`. The locale files keep ordinary spaces, so the
 * mark never wraps onto a line of its own.
 */
export function applyFrenchTypography<Tree extends TranslationTree>(translations: Tree): Tree {
    const copy = structuredClone(translations);
    spaceFrenchPunctuation(copy);
    return copy;
}

function spaceFrenchPunctuation(tree: TranslationTree): void {
    for (const [key, value] of Object.entries(tree)) {
        if (typeof value === 'string') {
            tree[key] = value
                .replaceAll(/[ \u00a0\u202f]([!;?])/g, '\u202f$1')
                .replaceAll(/[ \u00a0\u202f]([:»])/g, '\u00a0$1')
                .replaceAll(/«[ \u00a0\u202f]/g, '«\u00a0');
        } else {
            spaceFrenchPunctuation(value);
        }
    }
}
